import * as React from "react";
import {FontSizes, FontWeights, getTheme, Icon, Stack} from "@fluentui/react";
import {Link} from "react-router-dom";
import {textColorMatcher} from "../Utilities/textColorMatcher";

function LinkTile({to, color, title, icon, level}) {

    const theme = getTheme();
    const style = {
        root: {
            alignItems: 'middle',
            flexDirection: 'column',
            display: 'flex',
            height: 180,
            justifyContent: 'middle',
            overflow: 'hidden',
            width: 180,
            boxShadow: theme.effects.elevation8,
            backgroundColor: color,
            margin: 12,
            textAlign: 'left'
        },
    };


    const linkStyle = {
        textDecoration: "none",
        color: textColorMatcher(color)
    }
    let top = 10;
    if (title.length > 19 || level === 2) {
        top = -12;
    }
    if (title.length > 38 || level === 3) {
        top = -34;
    }

    return (
        <Link to={to} style={linkStyle}>
            <Stack.Item styles={style}>
                <Icon iconName={icon} styles={{root: {fontSize: FontSizes.size68, height: 50, margin: 45, textAlign: 'center'}}}/>
                <h5 style={{fontSize: FontSizes.size18, fontWeight: FontWeights.light, height: 20, margin: 0, textDecoration: "none", left: 10, top: top, display: "flex", position: "relative"}}>{title}</h5>
            </Stack.Item>
        </Link>
    )
}
export default LinkTile;

LinkTile.defaultProps = {
    level: 1,
}